module.exports = __webpack_public_path__ + "static/img/minicons2.61487b0a.png";